import { getData, postData } from '@/views/mped/services/mped-service';

export const setNvvTariff = async (args) => {
    return postData({
        url: '/mped/water-tariff',
        uuid: 'd0e4b95e-f6da-41f6-8f31-2583a8ef2ba0',
        args,
        throwError: true,
    });
};

export const getNvvTariff = async (args) => {
    return getData({
        url: '/mped/water-tariff',
        uuid: '422237c2-d29b-4d6f-8627-0412452d8db0',
        args
    });
};
